import { render, staticRenderFns } from "./navIcn.vue?vue&type=template&id=0648f24e&scoped=true&"
import script from "./navIcn.vue?vue&type=script&lang=js&"
export * from "./navIcn.vue?vue&type=script&lang=js&"
import style0 from "./navIcn.vue?vue&type=style&index=0&id=0648f24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648f24e",
  null
  
)

export default component.exports